import GameCardUI from "./GameCardUI";
import card_back from "../../../images/gameplay_ui/cards/back/train_card_back.png";
import train_front from "../../../images/gameplay_ui/cards/train_image.png";
import {LOCO_HEADER_COLOR} from "../GameStyleUI";
import GameWindowHeader from "../GameWindowHeader";

export default class PathGameCardUI extends GameCardUI {
    render() {
        this.cardBack = card_back;

        if (!this.props.card.isLucky) {
            let card = this.props.card;
            let styleFront = {
                position: "absolute",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                left: "0px",
                top: "0px",
                width: `${this.cardWidth}px`,
                height: `${this.cardHeight}px`,
                transform: `scale(${this.state.frontWidth}, ${this.state.backHeight})`,
                background: "#F2F2F2",
                borderRadius: "3px"
            }
            let textStyles = {
                textAlign: "left",
                width: "310px"
            }
            let colors = LOCO_HEADER_COLOR["electro"];

            const ids = card.pathsID;
            let place = "НА ";
            let title = "КАЖДЫЙ ЛОКОМОТИВ"
            if (ids) {
                place += ids.length > 1 ? "ПУТЯХ №" + ids.join(" И ") : "ПУТИ №" + ids[0]
                title = ids.length > 1 ? "ПУТИ №" + ids.join(" И ") : "ПУТЬ №" + ids[0]
            }

            this.contentCard = <div style={styleFront}>
                <div style={{height: "10px"}} />
                <GameWindowHeader width={310}
                                  height={50}
                                  colorStart={colors[0]}
                                  colorEnd={colors[1]}
                                  title={title}
                                  fontSize={20}
                                  topPosition={10}
                />
                <img src={train_front} alt={"icon"} onClick={this.hide.bind(this)}/>
                <div style={textStyles} className="loco-card">
                    <h3 style={{margin: "10px 0"}} className="loco-card__header">ПОЛОМКА ЛОКОМОТИВОВ</h3>
                    <p style={{margin: 0}} className="loco-card__content">ПОЛОМКА КАЖДОГО ЛОКОМОТИВА{ids ? " " + place : ""}, ИМЕЮЩЕГО СОСТОЯНИЕ {card.stateCondition} И МЕНЕЕ</p>
                </div>
            </div>;
        }
        return super.render();
    }
}
